import NotFoundPage from 'Components/NotFoundPage/NotFoundPage';
import Layout from 'Components/Layout';

import ClusterSites from 'FeatureModules/Site/Pages/ClusterSites';
import DataFormatSettings from 'FeatureModules/Setting/Pages/DataFormatSettings';
import PartnerComponentItems from 'FeatureModules/Partner/Pages/PartnerComponentItems';
import PartnerOverview from 'FeatureModules/Partner/Pages/PartnerOverview';
import PartnerSites from 'FeatureModules/Partner/Pages/PartnerSites';
import PlotDocuments from 'FeatureModules/Site/Pages/PlotDocuments';
import PlotOverview from 'FeatureModules/Site/Pages/PlotOverview';
import Plots from 'FeatureModules/Site/Pages/Plots';
import QuestionnaireAnswerForm from 'FeatureModules/Questionnaire/Pages/QuestionnaireAnswerForm';
import Questionnaires from 'FeatureModules/Questionnaire/Pages/Questionnaires';
import SiteActivities from 'FeatureModules/Site/Pages/SiteActivities';
import SiteDocuments from 'FeatureModules/Site/Pages/SiteDocuments';
import SiteOverview from 'FeatureModules/Site/Pages/SiteOverview';
import Sites from 'FeatureModules/Site/Pages/Sites';
import Activities from 'FeatureModules/Activity/Pages/Activities';
import ActivityOverview from 'FeatureModules/Activity/Pages/ActivityOverview';
import Can from 'FeatureModules/Auth/Components/Can';
import ComponentsLayout from 'FeatureModules/ComponentChain/Pages/ComponentsLayout';
import ComponentChainMapping from 'FeatureModules/ComponentChain/Pages/ComponentChainMapping';
import ComponentChainOverview from 'FeatureModules/ComponentChain/Pages/ComponentChainOverview';
import ComponentChains from 'FeatureModules/ComponentChain/Pages/ComponentChains';
import ComponentItemOverview from 'FeatureModules/ComponentChain/Pages/ComponentItemOverview';
import ComponentItems from 'FeatureModules/ComponentChain/Pages/ComponentItems';
import DataImportOverview from 'FeatureModules/DataImport/Pages/DataImportOverview';
import DataImports from 'FeatureModules/DataImport/Pages/DataImports';
import DatasetOverview from 'FeatureModules/DataImport/Pages/DatasetOverview';
import DocumentsLayout from 'FeatureModules/Document/Pages/DocumentsLayout';
import PartnerHome from 'FeatureModules/Home/Pages/PartnerHome';
import PartnerComponentsLayout from 'FeatureModules/Partner/Pages/PartnerComponentsLayout';
import React, { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import SettingsLayout from 'FeatureModules/Setting/Pages/SettingsLayout';
import DocumentOverview from 'FeatureModules/Document/Pages/DocumentOverview';
import InternalDocuments from 'FeatureModules/Document/Pages/InternalDocuments';
import SharedDocuments from 'FeatureModules/Document/Pages/SharedDocuments';
import MediaLibrary from 'FeatureModules/Media/Pages/MediaLibrary';
import PartnerActivities from 'FeatureModules/Partner/Pages/PartnerActivities';
import Partners from 'FeatureModules/Partner/Pages/Partners';
import Requests from 'FeatureModules/Request/Pages/Requests';
import CompanySettings from 'FeatureModules/Setting/Pages/CompanySettings';
import UserDetails from 'FeatureModules/Setting/Pages/UserDetails';
import UserList from 'FeatureModules/Setting/Pages/UserList';
import SecuritySettings from 'FeatureModules/Setting/Pages/SecuritySettings';
import PartnerComponentChains from 'FeatureModules/Partner/Pages/PartnerComponentChains';

const PartnerUIRouter: FC = () => (
  <Routes>
    <Route element={<Layout />}>
      {/* Home */}
      <Route path="/" element={<PartnerHome />} />

      {/* Components */}
      <Route
        path="/components"
        element={
          <ComponentsLayout selectedTab="components">
            <ComponentItems />
          </ComponentsLayout>
        }
      />
      <Route path="components/:id" element={<ComponentItemOverview />} />

      {/* Component chains */}
      <Route
        path="/component-chains"
        element={
          <ComponentsLayout selectedTab="component-chains">
            <ComponentChains />
          </ComponentsLayout>
        }
      />
      <Route path="/component-chains/:id" element={<ComponentChainOverview />} />
      <Route path="/component-chains/:id/editor" element={<ComponentChainMapping />} />

      {/* Partners */}
      <Route path="/partners" element={<Partners />} />
      <Route path="/partners/:id" element={<PartnerOverview />} />
      <Route path="/partners/:id/sites" element={<PartnerSites />} />
      <Route path="/partners/:id/activities" element={<PartnerActivities />} />
      <Route
        path="/partners/:id/components"
        element={
          <PartnerComponentsLayout selectedTab="components">
            <PartnerComponentItems />
          </PartnerComponentsLayout>
        }
      />
      <Route
        path="partners/:id/component-chains"
        element={
          <PartnerComponentsLayout selectedTab="component-chains">
            <PartnerComponentChains />
          </PartnerComponentsLayout>
        }
      />

      {/* Activities */}
      <Route path="/activities" element={<Activities />} />
      <Route path="/activities/:id" element={<ActivityOverview />} />

      {/* Sites */}
      <Route path="/sites" element={<Sites />} />
      <Route path="/sites/:id" element={<SiteOverview />} />
      <Route path="/sites/:id/sites" element={<ClusterSites />} />
      <Route path="/sites/:id/documents" element={<Navigate to="internal" />} />
      <Route path="/sites/:id/documents/internal" element={<SiteDocuments />} />
      <Route path="/sites/:id/activities" element={<SiteActivities />} />
      <Route path="/sites/:id/plots" element={<Plots />} />
      <Route path="/sites/:id/plots/:plotId" element={<PlotOverview />} />
      <Route path="/sites/:id/plots/:plotId/documents" element={<Navigate to="internal" />} />
      <Route path="/sites/:id/plots/:plotId/documents/internal" element={<PlotDocuments />} />

      {/* Documents */}
      <Route element={<DocumentsLayout />}>
        <Route path="/documents/internal" element={<InternalDocuments />} />
        <Route path="/documents/shared" element={<SharedDocuments />} />
      </Route>
      <Route
        path="/documents/internal/:documentId"
        element={<DocumentOverview documentType="INTERNAL" />}
      />
      <Route
        path="/documents/shared/:documentId"
        element={<DocumentOverview documentType="SHARED" />}
      />
      <Route
        path="/documents/requested/:documentId"
        element={<DocumentOverview documentType="PARTNER" />}
      />

      {/* Questionnaires */}
      <Route path="/questionnaires" element={<Questionnaires />} />
      <Route
        path="/questionnaires/:questionnaireId/answers/:questionnaireResponseId"
        element={<QuestionnaireAnswerForm />}
      />

      {/* Requests */}
      <Route path="/requests" element={<Requests />} />

      {/* Partners are deactivates for now until we have partner integration 1.4 */}
      {/* <Route path="/partners" element={<Partners />} />
      <Route path="/partners/:id" element={<PartnerOverview />} />
      <Route path="/partners/:id/activities" element={<PartnerActivities />} /> */}

      {/* Origin data import */}
      <Route path="/imports" element={<DataImports />} />
      <Route path="/imports/farms" element={<DataImportOverview />} />
      <Route path="/imports/farms/:importId" element={<DataImportOverview />} />
      <Route path="/imports/datasets" element={<DatasetOverview />} />
      <Route path="/imports/datasets/:datasetId" element={<DatasetOverview />} />

      {/* Media */}
      <Route path="/media-library" element={<MediaLibrary />} />

      {/* Settings */}
      <Route element={<SettingsLayout />}>
        <Route path="/settings" element={<UserDetails />} />
        <Route path="/settings/security" element={<SecuritySettings />} />
        <Route
          path="/settings/company"
          element={
            <Can rule="companySettings:access" no={() => <Navigate to="/settings" />}>
              <CompanySettings />
            </Can>
          }
        />
        <Route path="/settings/data-format" element={<DataFormatSettings />} />
        <Route
          path="/settings/users"
          element={
            <Can rule="userSettings:access" no={() => <Navigate to="/settings" />}>
              <UserList />
            </Can>
          }
        />
      </Route>
    </Route>

    {/* 404 */}
    <Route path="*" element={<NotFoundPage />} />
  </Routes>
);

export default PartnerUIRouter;
